import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AppProvider } from './AppContext'; // <-- Adjust path if needed
// Lazy-loaded pages
const Home = React.lazy(() => import("./components/pages/Home"));
const Hometwo = React.lazy(() => import("./components/pages/Hometwo"));
const About = React.lazy(() => import("./components/pages/About"));
const Blog = React.lazy(() => import("./components/pages/Blog"));
const Blogleft = React.lazy(() => import("./components/pages/Blogleft"));
const Blogdetail = React.lazy(() => import("./components/pages/Blogdetail"));
const Service = React.lazy(() => import("./components/pages/Service"));
const Servicedetail = React.lazy(() => import("./components/pages/Servicedetail"));
const Loancalculator = React.lazy(() => import("./components/pages/Loancalculator"));
const Loanstep = React.lazy(() => import("./components/pages/Loanstep"));
const Team = React.lazy(() => import("./components/pages/Team"));
const Finance = React.lazy(() => import("./components/pages/Finance"));
const Login = React.lazy(() => import("./components/pages/Login"));
const LoanConsultancyForm = React.lazy(() => import("./components/sections/loanConsultancyForm"));
const Comingsoon = React.lazy(() => import("./components/pages/Comingsoon"));
const Error = React.lazy(() => import("./components/pages/Error"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const Userdashboard = React.lazy(() => import("./components/pages/Userdashboard"));

// Route config object
const routeConfig = [
  { path: "/", component: Hometwo },
  { path: "/consultancy", component: LoanConsultancyForm },
  { path: "/about", component: About },
  { path: "/blog", component: Blog },
  { path: "/blog-sidebar", component: Blogleft },
  { path: "/blog-single/:id", component: Blogdetail },
  { path: "/service", component: Service },
  { path: "/service-detail/:id", component: Servicedetail },
  { path: "/loan-calculator", component: Loancalculator },
  { path: "/loan-step", component: Loanstep },
  { path: "/team", component: Team },
  { path: "/finance", component: Finance },
  { path: "/login", component: Login },

  // { path: "/coming-soon", component: Comingsoon },
  // { path: "/contact", component: Contact },
  { path: "/loan-dashboard", component: Userdashboard },
  { path: "/error", component: Error },
  { path: "*", component: Hometwo }
];

function App() {
  return (
    <AppProvider>
      <div className="main-body">
        <Router basename={
          '/'
          // "/themes/themeforest/react/loanly"
        }
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
              {routeConfig.map((route, index) => (
                <Route
                  key={index}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}
            </Switch>
          </Suspense>
        </Router>
      </div>
    </AppProvider>
  );
}

export default App;
